module.exports = __webpack_public_path__ + "static/media/name-cover.b3825efa.jpg";